import { Dialog } from 'alurkerja-ui'

export const errorHandler = (err: any) => {
  const message = err?.response?.data?.message
  const status = err?.response?.status

  let errorMessage = 'Silahkan coba lagi nanti'

  if (status === 422) {
    errorMessage = message
  } else if (message === 'ERROR LDAP') {
    errorMessage = 'Periksa kembali data kredensial'
  } else if (message === 'Bad Request' || message === 'BAD_REQUEST') {
    errorMessage = err?.response?.data?.data
  }

  Dialog.error({ description: errorMessage })
}
